import i18next from 'i18next';

export const positions = () => {
  return [
    { id: 1, name: i18next.t('technologist') },
    { id: 2, name: i18next.t('head_of_production') },
    { id: 3, name: i18next.t('cashier') },
  ];
};
